import { render } from "./Bayar.vue?vue&type=template&id=2e625fa9"
import script from "./Bayar.vue?vue&type=script&lang=js"
export * from "./Bayar.vue?vue&type=script&lang=js"

import "./Bayar.vue?vue&type=style&index=0&id=2e625fa9&lang=css"

import exportComponent from "/var/www/html/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__